export interface StandardApiError {
  message?: string;
  errorCode?: string;
  statusCode?: number;
  error?: string;
}

/** Keep the service's existing error fields while providing a real Error. */
export function createApiError<T extends { message: string }>(details: T): Error & T {
  return Object.assign(new Error(), details);
}

export async function getApiErrorMessage(
  response: Response,
  fallback: string,
): Promise<string> {
  try {
    const body = (await response.json()) as StandardApiError;
    return body.message || body.error || fallback;
  } catch {
    return fallback;
  }
}
